import {
  NotificationReminder,
  HubblFilter,
  Question,
  AdminInvitedEmployees,
} from 'hubbl-shared';

export enum EventFields {
  EVENT_TITLE = 'eventTitle',
  EVENT_DESCRIPTION = 'eventDescription',
  EVENT_EMOJI = 'eventEmoji',
  EVENT_LOCATION = 'eventLocation',
  EVENT_TAGS = 'eventTags',
  START_DATE_TIME = 'startDateTime',
  END_DATE_TIME = 'endDateTime',
  MARKETING_DATE_TIME = 'marketingStartDate',
  DEADLINE = 'deadline',
  COVER_IMAGE = 'coverImage',
  REMINDERS = 'reminders',
  EVALUATION_REMINDERS = 'evaluationReminders',
  EVALUATION_END_DATE = 'evaluationEndDate',
  EVALUATION_CUSTOM_DESCRIPTION = 'evaluationCustomDescription',
  IS_EVALUATION_ENABLED = 'isEvaluationEnabled',
  MAX_ATTENDEES = 'maxAttendees',
  INVITE_TYPE = 'adminInvitedEmployees',
  TICKET_SYSTEM_ENABLED = 'ticketSystemEnabled',
}

export type CreateEventFormType = {
  [EventFields.EVENT_TITLE]: string;
  [EventFields.EVENT_DESCRIPTION]: string;
  [EventFields.EVENT_EMOJI]: string;
  [EventFields.EVENT_LOCATION]: string;
  [EventFields.EVENT_TAGS]: string[];
  [EventFields.START_DATE_TIME]: string;
  [EventFields.END_DATE_TIME]: string | null;
  [EventFields.DEADLINE]: string | null;
  [EventFields.MARKETING_DATE_TIME]: string;
  [EventFields.COVER_IMAGE]: File | Blob;
  [EventFields.REMINDERS]: NotificationReminder[];
  [EventFields.EVALUATION_REMINDERS]: NotificationReminder[];
  [EventFields.EVALUATION_END_DATE]: string;
  [EventFields.EVALUATION_CUSTOM_DESCRIPTION]: string;
  [EventFields.IS_EVALUATION_ENABLED]: boolean;
  [EventFields.MAX_ATTENDEES]: number | null;
  [EventFields.INVITE_TYPE]: AdminInvitedEmployees;
  [EventFields.TICKET_SYSTEM_ENABLED]: boolean;
};

export type CreateEventDraft = Omit<
  CreateEventFormType,
  typeof EventFields.COVER_IMAGE
> & {
  [EventFields.COVER_IMAGE]: string | null;
  filters: HubblFilter[];
  questions: Question[];
  evaluationQuestions: Question[];
};

export interface Draft {
  id: string;
  title: string;
  data: CreateEventDraft;
  lastModified: string;
}
